import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import apiClient from "../../services/apiClient";

const AdminStoryManagement = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newStory, setNewStory] = useState("");
  const [newChapter, setNewChapter] = useState({ title: "", content: "", storyId: "" });
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [author, setAuthor] = useState("");
  const [source, setSource] = useState("");
  const [status, setStatus] = useState("in_progress");

  useEffect(() => {
    fetchStories();
    fetchCategories();
  }, []);

  const fetchStories = async () => {
    try {
      const response = await apiClient.get("/api/admin/stories");
      setStories(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching stories:", error);
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await apiClient.get("/api/v1/categories");
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleAddStory = async () => {
    try {
      await apiClient.post("/api/admin/stories", {
        story: { name: newStory, categories: selectedCategories, author, source, status },
      });
      setNewStory("");
      setSelectedCategories([]);
      setAuthor("");
      setSource("");
      setStatus("in_progress");
      fetchStories();
    } catch (error) {
      console.error("Error adding story:", error);
    }
  };

  const handleAddChapter = async () => {
    try {
      await apiClient.post(`/api/admin/chapters`, {
        title: newChapter.title,
        content: newChapter.content,
        story_id: newChapter.storyId,
      });
      setNewChapter({ title: "", content: "", storyId: "" });
      fetchStories();
    } catch (error) {
      console.error("Error adding chapter:", error);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Story Management</h1>
      
      <div className="mb-4">
        <h2 className="text-xl">Add New Story</h2>
        <input
          type="text"
          value={newStory}
          onChange={(e) => setNewStory(e.target.value)}
          placeholder="Story Title"
          className="border p-2 mr-2"
        />
        <select
          multiple
          value={selectedCategories}
          onChange={(e) => setSelectedCategories([...e.target.selectedOptions].map(option => option.value))}
          className="border p-2 mr-2"
        >
          {categories.map((category) => (
            <option key={category.id} value={category.id}>{category.name}</option>
          ))}
        </select>
        <input
          type="text"
          value={author}
          onChange={(e) => setAuthor(e.target.value)}
          placeholder="Author"
          className="border p-2 mb-2 w-full"
        />
        <input
          type="text"
          value={source}
          onChange={(e) => setSource(e.target.value)}
          placeholder="Source"
          className="border p-2 mb-2 w-full"
        />
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="border p-2 mb-2 w-full"
        >
          <option value="in_progress">Đang ra</option>
          <option value="completed">Đã hoàn thành</option>
          <option value="stopped">Đã tạm dừng</option>
        </select>
        <button onClick={handleAddStory} className="bg-blue-500 text-white p-2 rounded">
          Add Story
        </button>
      </div>

      <div className="mb-4">
        <h2 className="text-xl">Add New Chapter</h2>
        <select
          value={newChapter.storyId}
          onChange={(e) => setNewChapter({ ...newChapter, storyId: e.target.value })}
          className="border p-2 mr-2"
        >
          <option value="">Select Story</option>
          {stories.map((story) => (
            <option key={story.id} value={story.id}>{story.name}</option>
          ))}
        </select>
        <input
          type="text"
          value={newChapter.title}
          onChange={(e) => setNewChapter({ ...newChapter, title: e.target.value })}
          placeholder="Chapter Title"
          className="border p-2 mb-2 w-full"
        />
        <textarea
          value={newChapter.content}
          onChange={(e) => setNewChapter({ ...newChapter, content: e.target.value })}
          placeholder="Chapter Content"
          className="border p-2 mb-2 w-full"
          rows="4"
        />
        <button onClick={handleAddChapter} className="bg-blue-500 text-white p-2 rounded">
          Add Chapter
        </button>
      </div>

      <div className="overflow-x-auto mt-4">
        <table className="min-w-full bg-white border border-gray-300">
          <thead>
            <tr>
              <th className="px-6 py-3 border-b">ID</th>
              <th className="px-6 py-3 border-b">Title</th>
              <th className="px-6 py-3 border-b">Chapters</th>
            </tr>
          </thead>
          <tbody>
            {stories.map((story) => (
              <tr key={story.id}>
                <td className="px-6 py-4 border-b">{story.id}</td>
                <td className="px-6 py-4 border-b">
                  <Link to={`/admin/stories/${story.id}/detail`} className="text-blue-500 hover:underline">
                    {story.name}
                  </Link>
                </td>
                <td className="px-6 py-4 border-b">{story.chapter_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminStoryManagement; 